module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Note on Translations and Citations"
    }
  }, [_c('p', {
    staticClass: "fm_h",
    attrs: {
      "id": "sec2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rsec2"
    }
  }, [_vm._v("NOTE ON TRANSLATIONS AND CITATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EFERENCES TO THE")]), _vm._v(" "), _c('i', [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EPUBLIC")])]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WILL BE INCLUDED IN")]), _vm._v(" the text, identifying book and Stephanus pagination (e.g., I.343b); for quotations from the "), _c('i', [_vm._v("Republic")]), _vm._v(", I have used Bloom’s translation throughout. For other works of Plato, the Stephanus pagination will be preceded by the title of the work. For the "), _c('i', [_vm._v("Laws")]), _vm._v(", I quote Pangle’s translation; for the "), _c('i', [_vm._v("Phaedo")]), _vm._v(", I quote the translation by Brann, Kalkavage, and Salem; and for the "), _c('i', [_vm._v("Phaedrus")]), _vm._v(", I quote Scully’s translation. Unless otherwise indicated, all other translations of Plato are from "), _c('i', [_vm._v("Collected Works")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("For the works of Aristotle, I have used the translations in "), _c('i', [_vm._v("The Complete Works of Aristotle")]), _vm._v(", except for the "), _c('i', [_vm._v("Nicomachean Ethics")]), _vm._v(", for which I have used the translation by Bartlett and Collins."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206f6d2f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Note.vue
// module id = 81
// module chunks = 0